export default __webpack_public_path__ + "static/media/profile.68893968.PNG";